var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn sms-btn btn-lg d-flex rounded-pill p-0",on:{"click":function($event){return _vm.continueWithFolio()}}},[_c('p',{staticClass:"fb-text"},[_vm._v(_vm._s(_vm.$t('activate')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }